import React, { useEffect, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { SimpleForm } from "@/shared/components/text-box/simple-form";
import { useInstitutionsContext } from "@/features/institutions/contexts/institutions-context";
import { Dropdown } from "@/shared/components/dropdown/base-dropdown";
import { usePostFinanceAddinfoAccounts } from "@/features/accounts/finance/hooks/use-post-addinfo-accounts";
import { AccountsInfo } from "@/features/accounts/shared/hooks/use-select-accounts";


interface Props {
  onTapCloseModal: () => void;
  onTapCompleteModal: (accounts: AccountsInfo[]) => void;
}

export const AddAccountInfoModal = ({ onTapCloseModal, onTapCompleteModal }: Props) => {
  const {
    financeTypes,
    addinfoAccountsAccountGroupId,
    addinfoAccountsFinanceAccountId,
  } = useInstitutionsContext();
  const {
    registerFinanceAddinfoAccounts,
  } = usePostFinanceAddinfoAccounts();
  const [branchNumber, setBranchNumber] = useState("");
  const [accountTypeCode, setAccountTypeCode] = useState("");
  const [financeNumber, setFinanceNumber] = useState("");
  const [isActiveButton, setIsActiveButton] = useState(false);

  const onChangeBranchNumber = (value: string) => {
    setBranchNumber(value);
  };

  const onChangeAccountTypeCode = (value: string) => {
    setAccountTypeCode(value);
  }

  const onChangeFinanceNumber = (value: string) => {
    setFinanceNumber(value);
  };

  useEffect(() => {
    setIsActiveButton(branchNumber.length === 3 && accountTypeCode.length > 0 && financeNumber.length === 7);
  }, [branchNumber, accountTypeCode, financeNumber]);

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title="口座情報を入力"
      className="md-account-info"
      bottomChildren={
        <BaseRoundButton
          buttonText="設定"
          isActive={isActiveButton}
          onClick={async () => {
            const res = await registerFinanceAddinfoAccounts(
              addinfoAccountsAccountGroupId,
              addinfoAccountsFinanceAccountId,
              accountTypeCode,
              branchNumber,
              financeNumber,
            );
            onTapCompleteModal(res || []);
          }}
        />
      }
      disableOverlayClose={true}
    >
      <h2>
        口座情報を入力してください
      </h2>
      <dl>
        <dt>店番号</dt>
        <dd>
          <SimpleForm
            title="3桁の店番号"
            placeholder="3桁の店番号"
            onChange={(value) => onChangeBranchNumber(value)}
            maxLength={3}
          />
        </dd>
        <dt>口座タイプ</dt>
        <dd>
          <Dropdown
            className="dropdown-account-info"
            options={financeTypes.map((type) => ({
              label: type.finance_type_name,
              value: type.finance_type_code_bank,
            }))}
            defaultValue={{value: "__DEFAULT__", label: "口座タイプを選択" }}
            onChange={(value) => {
              onChangeAccountTypeCode(String(value))
            }}
          />
        </dd>
        <dt>口座番号</dt>
        <dd>
          <SimpleForm
            title="7桁の口座番号"
            placeholder="7桁の口座番号"
            onChange={(value) => onChangeFinanceNumber(value)}
            maxLength={7}
          />
        </dd>
      </dl>
    </BasePageModal>
  );
};

// TODO:現状は三菱UFJ[法人]でしか利用しないため専用の作りとするが、今後他の金融機関やサービスでも利用する可能性はある